import { createContext, useState } from "react";
import { translations } from "@/constants/translations";

export const SUPPORTED_LANGUAGES = [
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

const detectLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split("-")[0];
  if (SUPPORTED_LANGUAGES.some((l) => l.code === langCode)) {
    return langCode;
  }
  return "en";
};

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLanguage);

  const t = (key) => {
    const keys = key.split(".");
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  const toggleLang = () => {
    const codes = SUPPORTED_LANGUAGES.map((l) => l.code);
    const currentIndex = codes.indexOf(lang);
    const nextIndex = (currentIndex + 1) % codes.length;
    setLang(codes[nextIndex]);
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, toggleLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
